import React from 'react';
import { Box } from '@mui/material';

const TableShapeGlyph = ({
  shape = 'square',
  width = 40,
  height = 40,
  color = '#FFFFFF',
}) => {
  const radius =
    shape === 'round'
      ? Math.min(width, height) / 2
      : shape === 'bar'
        ? Math.min(width, height) / 2
        : shape === 'booth'
          ? 10
          : 7;

  return (
    <Box
      sx={{
        width,
        height,
        background: `linear-gradient(180deg, ${color} 0%, #EEF2F7 100%)`,
        border: '1.5px solid #CBD5E1',
        borderRadius: `${radius}px`,
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(15,23,42,0.10)',
      }}
    />
  );
};

export default TableShapeGlyph;
